export default __webpack_public_path__ + "static/media/i167hp.66e17d66.webp";